import { useIsCrmEnabled } from "@shared/access-control/useIsCrmEnabled";
import { useHasModule } from "@shared/access-control/useHasModule";
import { sidekickModuleEnum } from "@shared/access-control/sidekick-modules";
import type { SvgIconComponent } from "@mui/icons-material";
import PeopleIcon from "@mui/icons-material/People";
import AdjustIcon from "@mui/icons-material/Adjust";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import RadarIcon from "@mui/icons-material/Radar";

type SidebarNavItem = {
  id: "focus" | "radar" | "contacts" | "explore" | "presentations";
  label: string;
  to: string;
  icon: SvgIconComponent;
  comingSoon?: boolean;
  exact?: boolean;
  /** When true, the item should not be shown (e.g. gated by a feature flag in useChatSidebarNavItems). */
  hidden?: boolean;
};

const sidebarNavItems: SidebarNavItem[] = [
  {
    id: "focus",
    label: "Focus",
    to: "/",
    icon: AdjustIcon,
    exact: true,
  },
  {
    id: "radar",
    label: "Signals",
    to: "/signals",
    icon: RadarIcon,
  },
  {
    id: "explore",
    label: "Explore",
    to: "/explore",
    icon: TravelExploreIcon,
  },
  {
    id: "contacts",
    label: "Contacts",
    to: "/contacts",
    icon: PeopleIcon,
  },
  {
    id: "presentations",
    label: "Presentations",
    to: "/presentations",
    icon: DescriptionOutlinedIcon,
  },
];

export const useChatSidebarNavItems = () => {
  const isCrmEnabled = useIsCrmEnabled() === true;
  const hasRadarModule = useHasModule(sidekickModuleEnum.RADAR);
  const hasMlsAccessModule = useHasModule(sidekickModuleEnum.MLS_ACCESS);

  return sidebarNavItems
    .map((item) => {
      if (item.id === "presentations") {
        return { ...item, hidden: !hasMlsAccessModule };
      }
      if (item.id === "focus") {
        return { ...item, hidden: !isCrmEnabled || !hasMlsAccessModule };
      }
      if (item.id === "contacts") {
        return { ...item, hidden: !isCrmEnabled };
      }
      if (item.id === "radar") {
        return { ...item, hidden: !hasRadarModule };
      }
      if (item.id === "explore") {
        return { ...item, hidden: !hasMlsAccessModule };
      }
      return item;
    })
    .filter((item) => !item.hidden);
};
